import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom"; 
import { getAllDocumentos } from "../../redux/documentos/documentosAction";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format, parse, startOfWeek, getDay, getMonth } from "date-fns";
import { enUS } from "date-fns/locale/en-US";
import "react-big-calendar/lib/css/react-big-calendar.css";
import './calendarioStyles.css'


export default function Calendario(){
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const documentos = useSelector(state => state.documentos.allDocumentos)

    useEffect(() => {
        dispatch(getAllDocumentos())
    }, [dispatch]);

    console.log(documentos);
    
    
    let arrayCalendar = []

    const calendar = documentos[0] !== undefined ? documentos[0].map(e => {
        //if(e.state === false){
        const calendarDoc = {
            id: e._id,   
            title: "N° Doc " + e.numDocumento + " - " + e.cliente.nombre,
            allDay: true,
            start: new Date(e.createdAt),
            end : new Date(e.createdAt),
            armado: e.armado,
            entregado: e.entregado
        }
        return arrayCalendar.push(calendarDoc)
    //}
    }) 
    : null;
    console.log(arrayCalendar)

    const locales = {
        "en-US": enUS //es el area donde refiere nuestro calendario, de momento va por defecto  en-US
    }

    const localizer = dateFnsLocalizer({    // traemos las dife
        format,            //formato de fecha
        parse,             //analizador
        startOfWeek,       //principio de semana
        getDay,            //obtener dia
        getMonth,
        locales             
    })

    const linkDocument = (e) => {
        console.log(e.id)
        navigate(`/documentoDetalle/${e.id}`)        
    } 

    const components = {
        event: (props) => {
            //console.log("props", props.event);
            const eventState = props.event;
            console.log(eventState.state)
            if(eventState.entregado === true){
                return <div className="bg-green-400 text-[8pt] text-black font-bold">{eventState.title}</div>
            }
            if(eventState.armado === false && eventState.entregado === false){
                return <div className="bg-red-500 text-[8pt] text-white font-bold">{eventState.title}</div>
            }
            if(eventState.armado === true && eventState.entregado === false ){
                return <div className="bg-yellow-300 text-[8pt] text-black font-bold">{eventState.title}</div>
            }
        }
    }

    return(
        <div className="bg-custom container-custom">
            <p className="text-orange-500">Calendario</p>
            <div className="flex text-center ml-2 w-1/3 bg-slate-600">
              <p className="text-green-400 text-[10pt] font-bold w-1/3">Entregado</p>
              <p className="text-red-500 text-[10pt] font-bold w-1/3">Sin Armar</p>
              <p className="text-yellow-500 text-[10pt] font-bold w-1/3">Armado</p>  
            </div>
            <div className="">
                <Calendar 
                    localizer={localizer}
                    events={arrayCalendar}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 1000, margin:"10px", color: "#f97316"}}
                    showAllEvents
                    components={components}
                    //onDoubleClickEvent={linkDocument}
                    onSelectEvent={linkDocument}
                    
                />                
             </div>
        </div>
    )
} 